import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { PublicSvgIcon } from "~/components/public_svg_icon";

export interface HideableTextProps {
  value: string;
  initiallyHidden?: boolean;
  label?: string;
  dataTestId?: string;
}

export function HideableText({
  value,
  initiallyHidden = true,
  label,
  dataTestId,
}: HideableTextProps) {
  const [isHidden, setIsHidden] = useState<boolean>(initiallyHidden);

  const toggleHidden = () => setIsHidden((prev) => !prev);

  return (
    <Stack
      direction="row"
      spacing={2.5}
      alignItems="center"
      data-testid={dataTestId}
    >
      {label && <Typography variant="body1">{label}</Typography>}
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Typography variant="body2" color="text.secondary">
          {isHidden ? "••••••••••" : value}
        </Typography>
        <IconButton size="small" onClick={toggleHidden}>
          <PublicSvgIcon name={isHidden ? "visibility" : "visibility_off"} />
        </IconButton>
      </Stack>
    </Stack>
  );
}
